import React from "react";
import "./styles.css";

export const WhiteFlash = ({ isShowWhiteFlash }) => {
  const flashDoTransition = isShowWhiteFlash ? "do-transition" : "";
  const flashClasses = `${flashDoTransition} normal`;

  return <div id="white-flash" className={flashClasses}></div>;
};
